import { useEffect } from 'react';

/**
 * @hook useBeforeUnload
 * @description
 * Hook personalizado que intercepta el evento `beforeunload` del navegador para detectar 
 * cuando el usuario intenta recargar o cerrar la pestaña. También marca en `sessionStorage` 
 * que ocurrió un intento de recarga.
 *
 * Esto puede ser útil para preservar estado temporal, evitar pérdida de progreso en formularios,
 * o enviar notificaciones al backend antes de que el usuario abandone la página.
 *
 * @returns {void} No retorna ningún valor.
 */
const useBeforeUnload = () => {
	useEffect(() => {
		/**
		 * Manejador del evento `beforeunload` que previene la acción predeterminada
		 * y establece una bandera en `sessionStorage` indicando que se está recargando la página.
		 *
		 * @param {BeforeUnloadEvent} event - Evento del navegador.
		 */
		const handleBeforeUnload = (event) => {
			event.preventDefault();
			event.returnValue = ''; // Necesario para que se muestre el prompt en algunos navegadores

			// 🔹 Marca el intento de recarga en sessionStorage
			sessionStorage.setItem('reloading', 'true');
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, []);
};

export default useBeforeUnload;